import { useDispatch } from 'react-redux'

import { IReleaseNote } from '@cbgms/api/modules/releasenotes'
import SupportListWrapper from 'core/page/SupportListWrapper'
import N from 'utils-support/navigation'
import { IColumn } from '@cbgms/components/grid/Types'
import { deleteReleaseNote, listReleaseNotes } from '../state/actions'
import { useTranslation } from 'react-i18next'
import { useNotifier } from '@cbgms/base/notifier'

const onColumnMap = (columns: IColumn[]) => columns.filter(column => column.key !== 'ReleaseNote.URLs')

const onAdd = () => {
  N.push('/release-notes/new')
}

const onEdit = (data: { ReleaseNote: IReleaseNote }) => {
  N.push(`/release-notes/edit/${data.ReleaseNote.UUID}`)
}

const ReleaseNotesList = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const notifier = useNotifier()

  const onDelete = async (row: { ReleaseNote: IReleaseNote }, dryRun: boolean) => {
    await dispatch(deleteReleaseNote(row.ReleaseNote.UUID, dryRun))

    notifier.success(t('releasenotes.deleted_successfully'))
  }

  return (
    <SupportListWrapper
      scope='release-notes'
      type='list'
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      skipDryRun
      onColumnMap={onColumnMap}
      loadAction={listReleaseNotes}
      translationKey='releasenotes'
    />
  )
}

export default ReleaseNotesList
